exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#Header{padding-bottom:480px}.table-responsive{overflow:hidden!important}table th{background:unset!important;background-color:#fbb500;color:#c80029;border:0}th.table-stjawhite{background-color:#ffd965!important}.col-pagination{padding-left:0}.row-select{margin:0}.b-table-details{background-color:#fff}.card{border:none}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}button.page-link.flex-grow-1{background-color:#fff!important;margin:0;border:1px solid #dee2e6;height:max-content!important;width:unset}button.page-link.flex-grow-1:hover{background-color:#e9ecef!important;color:#d52036!important}.page-item.active .page-link{border-color:#d52036!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-692db6fd","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TableWrapper.vue
// module id = 622
// module chunks = 0